import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse, // Introduction
  faWandMagicSparkles, // Key Skills
  faBriefcase, // Recent Experiences
  faFolderOpen, // Previous Projects
  faGraduationCap, // Education
  faHiking, //Hobbies
} from "@fortawesome/free-solid-svg-icons";

import "../assets/Navigation.scss";

export default function Navigation({ isShown }) {
  return (
    <div className={`navigation ${isShown ? "navigation--open" : ""}`}>
      <ul className="navigation__content">
        <li>
          <NavLink className="navigation__item" to="/" end>
            <FontAwesomeIcon icon={faHouse} className="navigation__icon" />
            <span>Introduction</span>
          </NavLink>
        </li>
        <li>
          <NavLink className="navigation__item" to="/about">
            <FontAwesomeIcon
              icon={faWandMagicSparkles}
              className="navigation__icon"
            />
            <span>Key Skills</span>
          </NavLink>
        </li>
        <li>
          <NavLink className="navigation__item" to="/experience">
            <FontAwesomeIcon icon={faBriefcase} className="navigation__icon" />
            <span>Recent Experiences</span>
          </NavLink>
        </li>
        <li>
          <NavLink className="navigation__item" to="/previouswork">
            <FontAwesomeIcon icon={faFolderOpen} className="navigation__icon" />
            <span>Previous Projects</span>
          </NavLink>
        </li>
        <li>
          <NavLink className="navigation__item" to="/education">
            <FontAwesomeIcon
              icon={faGraduationCap}
              className="navigation__icon"
            />
            <span>Education</span>
          </NavLink>
        </li>
        <li>
          <NavLink className="navigation__item" to="/hobbies">
            <FontAwesomeIcon icon={faHiking} className="navigation__icon" />
            <span>Hobbies</span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
